"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourSegmentTests = void 0;
var increment_hours_1 = require("./increment-hours");
var decrement_hours_1 = require("./decrement-hours");
var delete_hours_1 = require("./delete-hours");
var from_blank_hours_1 = require("./from-blank-hours");
var _24_hour_value_tests_1 = require("./24-hour-value-tests");
var utils_1 = require("../../support/utils");
var HourSegmentTests = /** @class */ (function (_super) {
    __extends(HourSegmentTests, _super);
    function HourSegmentTests(utils) {
        var _this = _super.call(this, utils) || this;
        _this.increment = function () { return (0, increment_hours_1.incrementHours)(utils); };
        _this.decrement = function () { return (0, decrement_hours_1.decrementHours)(utils); };
        _this.delete = function () { return (0, delete_hours_1.deleteHours)(utils); };
        _this.fromBlank = function () { return (0, from_blank_hours_1.fromBlankHours)(utils); };
        _this.hrs24Values = function () { return (0, _24_hour_value_tests_1.hrs24Values)(utils); };
        return _this;
    }
    return HourSegmentTests;
}(utils_1.TestSuite));
exports.HourSegmentTests = HourSegmentTests;
